<ng-container *mobxAutorun>
  <i
    *ngIf="icon"
    [ngClass]="classes"
    [attr.aria-hidden]="ariaHidden ? 'true' : 'false'"
  >
  </i>
</ng-container>
